function t(r) {
  return typeof r != "string" ? !1 : !Number.isNaN(r) && !Number.isNaN(parseFloat(r)) && /^-?\d+\.?\d*$/.test(r);
}
export {
  t as isNumberString
};
